"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _trackingBirthdayDiscount = require("@/api/tracking-birthday-discount");
var _moment = _interopRequireDefault(require("moment"));
var TrackingBirthdayDiscount = /*#__PURE__*/function (_Vue) {
  function TrackingBirthdayDiscount() {
    var _this;
    (0, _classCallCheck2.default)(this, TrackingBirthdayDiscount);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, TrackingBirthdayDiscount, [].concat(args));
    (0, _defineProperty2.default)(_this, "customerId", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10,
      year: (0, _moment.default)().format("YYYY")
    });
    (0, _defineProperty2.default)(_this, "loading", false);
    return _this;
  }
  (0, _inherits2.default)(TrackingBirthdayDiscount, _Vue);
  return (0, _createClass2.default)(TrackingBirthdayDiscount, [{
    key: "watchCustomerId",
    value: function watchCustomerId() {
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _trackingBirthdayDiscount.trackingUseBirthdayDiscountApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), {}, {
                customerId: this.customerId
              }));
            case 2:
              res = _context.sent;
              this.data = res.data.tracings;
              this.total = res.data.total;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], TrackingBirthdayDiscount.prototype, "customerId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("customerId", {
  deep: true,
  immediate: true
})], TrackingBirthdayDiscount.prototype, "watchCustomerId", null);
TrackingBirthdayDiscount = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], TrackingBirthdayDiscount);
var _default = exports.default = TrackingBirthdayDiscount;